import { parseDateToISOFormat } from "src/utils/calendarUtils";
import { useGetAmountOfRegisteredEmpresasQuery } from "../../empresaApi";
import { CounterPerProspectador } from "./CounterPerProspectador";
import { CounterPerDates } from "./CounterPerDates";

interface Props {
    fechaInicio: string;
    fechaFin: string;
    prospectadorId: string;
}

export function EmpresaCounter({ fechaInicio, fechaFin, prospectadorId }: Props) {
    const today = parseDateToISOFormat(new Date());

    const { data } = useGetAmountOfRegisteredEmpresasQuery({
        fechaInicio: fechaInicio.length == 0
            ? today
            : fechaInicio,
        fechaFin: fechaFin.length == 0
            ? today
            : fechaFin,
        prospectadores: prospectadorId != "0" && prospectadorId.length > 0
            ? [prospectadorId]
            : undefined,
    });

    return (
        <>
            <CounterPerDates 
                totalEmpresas={data?.totalEmpresasRegistradas ?? 0}
                fechaInicio={data?.fechaInicio ?? ""}
                fechaFin={data?.fechaFin ?? ""}/>

            {data?.prospectadores && data?.prospectadores.length > 0 && (
                <CounterPerProspectador 
                    prospectadores={data.prospectadores}/>
            )}
        </>
    );
}